export class ResetPassword {

  new_password: string;
  re_new_password: string;
  current_password: string;

}
